import axios from 'axios';
import { message } from 'antd';
import { getAccessToken } from '../../authService';
import InternalApi from '../axios/internalApi';
const token = getAccessToken();

export const getSetupCost = async () => {
  try {
    const res = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_KEY}api/v1/business/`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const listPrices = async () => {
  try {
    return await InternalApi.get({
      server: 'api/v1/',
      path: `admin/list-prices`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createPrice = async (payload) => {
  try {
    return await InternalApi.post(
      {
        server: 'api/v1/',
        path: `admin/create-price`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updatePrice = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: 'api/v1/',
        path: `admin/update-price/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};
